import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { _axios } from "../../plugins/axios";
import TitleHeader from "../common/titleHeader";
import { URL, USER } from "../../constants/constant";

const validMobileRegex = RegExp(/^[6-9]\d{9}$/i);
class DependantOTPCustomer extends Component {
  constructor(props) {
    super(props);
    console.log(this.props);
    this.state = {
      otpVerificationCheck: true,
      sendOTP: false,
      verifyOTP: false,
      phoneNumber: localStorage.getItem("customer_phoneNumber") ? JSON.parse(localStorage.getItem("customer_phoneNumber")) : "",
      otp: null,
      otpDataId: null,
      showMessage: null,
      errors: {
        phoneNumber: "",
      },
      skipState: false,
      relatedOrders: [],
      relatedOrdersModal: false,
      currentOrder: [],
      userdata: USER.user,
      isLoaded: false,
      dependantId: this.props.match.params.dependantId.toString(),
    };
  }

  async componentDidMount() {
    this.setState({
      isLoaded: true,
      skipState: !["Mysuru", "Kochi", "Visakhapatnam", "Jaipur"].includes(this.state.userdata.city),
    });
  }

  removeLocalStorage() {
    localStorage.removeItem("customer_phoneNumber");
    localStorage.removeItem("upsellMemberDetailsConfirm");
    localStorage.removeItem("orderTestDetails");
    localStorage.removeItem("upsellOrderIds");
    localStorage.removeItem("order_details");
    localStorage.removeItem("order_details");
    localStorage.removeItem("phlebo_start_order_trip_details");
    localStorage.removeItem("AppointmentDate");
    localStorage.removeItem("AppointmentId");
    localStorage.removeItem("City");
    localStorage.removeItem("DID");
    USER.orderDetails = null;
  }

  skipOTP() {
    this.props.history.push("/dependantOrders/pending");
    this.removeLocalStorage();
    // this.setState({ relatedOrdersModal: true })
  }

  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    let errors = this.state.errors;

    switch (name) {
      case "phoneNumber":
        errors.phoneNumber = validMobileRegex.test(value) ? this.setState({ phoneNumber: value }) : "Phone Number must be valid";
        break;
      default:
        break;
    }

    this.setState({ errors, [name]: value });
  };

  sendOTP() {
    let that = this;
    console.log(this.state);
    const url = URL.dev_url;
    _axios
      .post(`${url}sendOTPForUsers`, { phonenumber: this.state.phoneNumber.toString(), type: "OTP_Validation" })
      .then(function (response) {
        console.log(response.data);
        that.setState({
          sendOTP: response.data.success,
          otpDataId: response.data.otpDataId,
          showMessage: null,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  verifyOtp(event) {
    const { name, value } = event.target;
    if (value.length == 4) {
      this.setState({
        otp: value,
      });
    } else {
      console.log("otp..", value);
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    let that = this;
    let url = URL.dev_url;
    let route = url + "verifyotp";
    console.log(route)

    _axios
      .post(route, {
        phonenumber: this.state.phoneNumber,
        otp: this.state.otp,
        otpEvent: "customer",
        otpDataId: this.state.otpDataId ? this.state.otpDataId : null,
        dependantId: this.state.dependantId,
        executeAtPatientLevel: true,
      })
      .then(function (response) {
        if (response.data.otpStatus) {
          that.setState(
            {
              showMessage: null,
            },
            () => {
              that.removeLocalStorage();
              that.props.history.push("/dependantOrders");
            }
          );
        } else if (!response.data.otpStatus) {
          that.setState({
            showMessage: "Invalid OTP !",
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  routeToSampleDetails() {
    // let orderId = localStorage.getItem("orderId");
    this.props.history.push(`/dependantSample/collectedCompleted/${this.state.dependantId}`);
  }

  render() {
    const { errors } = this.state;
    return this.state.isLoaded ? (
      <div className="order-details-dashboard">
        <div>
          <TitleHeader title="ENTER OTP" subtitle="Otp has been sent to Customer's Phone" secondsubtitle="Please Enter 4 digit OTP"></TitleHeader>
        </div>
        <Container>
          <Row className="m-t-50">
            <Col xs={12} md={12}>
              <Form onSubmit={(e) => this.handleSubmit(e)}>
                <Form.Group>
                  <Form.Label htmlFor="phoneNumber">Phone Number</Form.Label>
                  <Form.Control
                    type="number"
                    name="phoneNumber"
                    value={this.state.phoneNumber}
                    disabled={true}
                    placeholder="Enter Phone Number"
                    onChange={(e) => this.handleChange(e)}
                  />
                  {errors.phoneNumber && <span className="font-size-sm gray-color">{errors.phoneNumber}</span>}
                </Form.Group>

                <Form.Group>
                  <Form.Label htmlFor="otp">OTP</Form.Label>
                  <Form.Control type="password" name="otp" placeholder="Password" onChange={(e) => this.verifyOtp(e)} />
                </Form.Group>
                <div className="p-b-10">
                  {this.state.sendOTP ? (
                    <>
                      <Button variant="primary" type="submit" className="text-align-center w-100" disabled={errors.phoneNumber}>
                        {" "}
                        Verify OTP{" "}
                      </Button>
                      <div
                        className="text-align-center p-t-10 base-color font-size-smd bold"
                        onClick={(e) => this.sendOTP(e)}
                        disabled={errors.phoneNumber}
                      >
                        Resend OTP
                      </div>
                      <div className="text-align-center red-color font-size-smd bold p-t-10 ">{this.state.showMessage}</div>
                    </>
                  ) : (
                    <Button
                      variant="primary"
                      type="button"
                      onClick={(e) => this.sendOTP(e)}
                      disabled={errors.phoneNumber}
                      className="text-align-center w-100"
                    >
                      {" "}
                      Send OTP{" "}
                    </Button>
                  )}
                </div>
                {this.state.skipState && (
                  <div className="p-b-20">
                    <Button variant="info" type="submit" className="text-align-center w-100" onClick={(e) => this.skipOTP(e)}>
                      {" "}
                      SKIP{" "}
                    </Button>
                  </div>
                )}
              </Form>
            </Col>
          </Row>

          <Row>
            <div className="fixed-bottom p-l-15 p-r-15 p-t-5 p-b-5">
              <div className="display-flex justify-content-space-between">
                <Col>
                  <button type="button" className="btn btn-outline-primary width-100 border-curve-10" onClick={() => this.routeToSampleDetails()}>
                    Back
                  </button>
                </Col>
              </div>
            </div>
          </Row>
        </Container>
      </div>
    ) : (
      <>Loading...</>
    );
  }
}
export default DependantOTPCustomer;
